
import { Language } from './types';

export const TRANSLATIONS: Record<string, any> = {
  [Language.KURDISH]: {
    appName: "هاوڕێ",
    tagline: "هاوڕێ؛ یاریدەدەری زیرەکی شێوازی ژیان و ڕاهێنەری ئارامی مێشک",
    welcome: "سڵاو، {name}ـی ئازیز!",
    dashboard: "داشبۆرد",
    companion_live: "ناوەندی ئاخاوتن",
    chat: "گفتوگۆ",
    calm: "ئارامی",
    social_training: "ڕاهێنانی کۆمەڵایەتی",
    community: "کۆمەڵگا",
    companion: "هاوسەفەر و ئەدەبیات",
    modules: "ئامرازەکان",
    timeline: "یادەوەرییەکان",
    profile: "پرۆفایل",
    logout: "چوونەدەرەوە",
    start_journey: "دەستپێکردن",
    select_companion: "هاوسەفەر هەڵبژێرە",
    name_placeholder: "ناوەکەت بنووسە...",
    continue: "بەردەوام بە",
    save: "پاشەکەوت",
    cancel: "پەشیمان بوونەوە",
    edit_profile: "دەستکاری پرۆفایل",
    language: "زمان",
    kurdish: "کوردی",
    persian: "فارسی",
    back: "گەڕانەوە",
    send: "ناردن",
    end_session: "کۆتایی",
    try_again: "دووبارە",
    physical: "جەستەیی",
    mental: "دەروونی",
    social: "کۆمەڵایەتی",
    professional: "پیشەیی",
    financial: "دارایی",
    balance: "هاوسەنگی ژیان",
    level: "ئاست",
    xp: "خاڵ",
    ai_analysis: "شیکاری هاوڕێ",
    immediate_calm: "ئارامی خێرا",
    memory_record: "تۆمارکردن",
    social_practice: "هاوکاری",
    chat_status: "ئامادەیە",
    chat_welcome_title: "بەخێربێیت بۆ چات",
    chat_welcome_desc: "هاوڕێ لێرەیە بۆ گفتوگۆ و یارمەتیدانت.",
    chat_thinking: "خەریکی بیرکردنەوەم...",
    chat_placeholder: "پەیامێک بنووسە...",
    onboarding_title: "بەخێربێیت بۆ هاوڕێ",
    onboarding_subtitle: "ناوەکەت چییە؟",
    onboarding_privacy: "زانیارییەکانت پارێزراون.",
    install_title: "دامەزراندنی ئەپ",
    install_desc: "بۆ کارکردنی خێراتر ئەپەکە دابمەزرێنە.",
    install_btn: "ئێستا دایبمەزرێنە",
    select_country: "وڵات هەڵبژێرە",
    country_kurdistan: "کوردستان",
    country_iran: "ئێران",
    country_iraq: "ئێراق",
    country_other: "وڵاتی تر",
    select_ai_engine: "مۆتۆڕی زیرەکی دەستکرد",
    engine_desc: "دەتوانی مۆتۆڕی وەڵامدانەوەی هاوڕێ بگۆڕیت.",
    gemini_label: "جمینای (Google)",
    deepseek_label: "DeepSeek",
    grok_label: "Grok (xAI)",
    // Personality
    personality_title: "کەسایەتی هاوڕێ هەڵبژێرە",
    personality_subtitle: "هاوڕێ دەتوانێت بە چەند شێوازێک لەگەڵت بێت.",
    personality_butterfly: "پەپوولەی گۆڕانکار",
    personality_butterfly_desc: "کۆمەڵایەتی و پڕ لە وزە",
    personality_butterfly_details: "هانت دەدات بۆ گۆڕانکاری و شتی نوێ.",
    personality_mountain: "شاخی سەربەرز",
    personality_mountain_desc: "جێگیر و متمانەپێکراو",
    personality_mountain_details: "بە هێمنی ڕێنماییت دەکات.",
    personality_lamp: "چرای زیرەک",
    personality_lamp_desc: "ڕۆشنبیر و لۆژیکی",
    personality_lamp_details: "بە زانیاری ڕێگەت بۆ ڕوون دەکاتەوە.",
    personality_gardener: "باخەوانی ژیان",
    personality_gardener_desc: "بەبەزەیی و پشتگیر",
    personality_gardener_details: "ئاگاداری گەشەی تۆ دەبێت.",
    // Live Companion Keys
    live_status_connected: "پەیوەستە",
    live_status_connecting: "خەریکی پەیوەستبوونە...",
    speech_coach_ready: "ئامادەی بۆ ڕاهێنان؟",
    speech_mode_tech: "تەکنیکی",
    speech_mode_public: "وتار",
    speech_mode_poetic: "شیعر",
    speech_mode_daily: "ڕۆژانە",
    speech_tip_tech: "وشەی ورد و لۆژیکی بەکاربێنە.",
    speech_tip_public: "بە دەنگی بەرز و ڕوون قسە بکە.",
    speech_tip_poetic: "هەست و سۆزت تێکەڵی قسەکانت بکە.",
    speech_how_it_works: "چۆن کار دەکات؟",
    speech_step_1: "مۆدێک هەڵبژێرە.",
    speech_step_2: "دەستپێکردن دابگرە.",
    speech_step_3: "بە کوردی یان فارسی قسە بکە.",
    speech_metric_clarity: "ڕوونی",
    speech_metric_pace: "خێرایی",
    speech_metric_emotion: "هەست",
    speech_coach_feedback: "فیدباکی ڕاهێنەر",
    // Tools
    tools_portal: "ناوەندی ئامرازەکان",
    tools_portal_desc: "ئامرازی زیرەک بۆ ڕێکخستنی ژیانی ڕۆژانە.",
    advanced_ai: "زیرەکی دەستکردی پێشکەوتوو",
    advanced_ai_desc: "شیکاری قووڵ و پێشبینی داهاتوو.",
    cooking_tool: "چێشتلێنان",
    cooking_desc: "دروستکردنی ڕەچەتەی خواردن.",
    tasks_tool: "کارەکان",
    tasks_tool_desc: "دابەشکردنی کارە گەورەکان.",
    health_tool: "تەندروستی",
    health_tool_desc: "پلانی وزە و تەندروستی.",
    finance_tool: "دارایی",
    finance_tool_desc: "شیکاری خەرجییەکان.",
    learning_tool: "فێربوون",
    learning_tool_desc: "کورتەی هەر بابەتێک.",
    travel_tool: "گەشت",
    travel_tool_desc: "پلانی گەشت بۆ هەر شوێنێک.",
    back_to_hub: "گەڕانەوە بۆ ناوەند",
    generate_now: "ئێستا دروست بکە",
    // Community
    safe_community: "کۆمەڵگای پارێزراو",
    anonymous_chat_desc: "گفتوگۆ بکە بەبێ ئەوەی ناوت ئاشکرا بێت.",
    identity_protected: "ناسنامەت پارێزراوە",
    comm_type_msg: "پەیامێک بنووسە...",
    comm_first_msg: "یەکەم پەیام بنێرە!",
    rooms_tab: "ژوورەکان",
    companions_tab: "هاوسەفەرەکان",
    comm_find_companion: "دۆزینەوەی هاوسەفەر",
    comm_companion_desc: "کەسێک بدۆزەوە کە لەگەڵ بیرکردنەوەت دەگونجێت.",
    comm_searching: "خەریکی گەڕانم...",
    comm_find_btn: "گەڕان بۆ هاوسەفەر",
    comm_active_members: "{count} ئەندامی چالاک",
    anonymous_name_is: "ناوی تۆ لێرە: {name}",
    // Social
    social_academy_title: "ئەکادیمیای کۆمەڵایەتی",
    social_academy_desc: "هونەری قسەکردن و گفتوگۆ لەگەڵ کەسانی جیاواز فێر ببە.",
    social_start_sim: "دەستپێکردنی شبیەسازی",
    social_feedback_title: "شیکاری و فیدباک",
    social_back_to_groups: "گەڕانەوە بۆ گرووپەکان",
    social_principles: "بنەماکانی گفتوگۆ",
    // Companion Hub Extra
    wisdom_day: "حکمت و پەند",
    poetry_literature: "شیعر و ئەدەب",
    fun_time: "شوخی و پێکەنین",
    joke_contest: "پێشبڕکێی نوکتە",
    favorites: "دڵخوازەکان",
    motivational: "هاندەر",
    philosophical: "فەلسەفی",
    romantic: "عاشقانە",
    calm_cat: "ئارامکەرەوە",
    classic_poetry: "شیعری کلاسیک",
    modern_poetry: "شیعری نوێ",
    mystic_poetry: "عیرفانی",
    haiku_poetry: "هایکۆ",
    generating_content: "خەریکی دروستکردنم...",
    select_topic_smile: "بابەتێک هەڵبژێرە تا هاوڕێ بۆت دروست بکات",
    joke_judge: "نوکتەیەک بنووسە",
    send_to_judge: "بنێرە بۆ داوەر",
    no_favorites: "لیستەکە بەتاڵە.",
    wisdom_letter_title: "نامەی حکمت",
    // Prediction
    prediction_lab_title: "تاقیگەی پێشبینی",
    prediction_lab_desc: "شیکاری سیناریۆکانی ژیان و ئەگەرەکانی داهاتوو.",
    decision_simulator: "شبیەسازی بڕیار",
    predictive_alerts: "ئاگادارکەرەوەکان",
    decision_prompt: "چ بڕیارێکت لە مێشکدایە؟",
    prediction_scenario_btn: "شیکاری سیناریۆ",
    prediction_impact_5yr: "تأسیری ٥ ساڵە",
    // Digital Balance
    digital_balance: "هاوسەنگی دیجیتاڵ",
    offline_challenge: "چالی ئۆفلاین",
    micro_learning: "فێربوونی خێرا",
    daily_class: "کلاسی ڕۆژانە",
    creative_studio: "ستۆدیۆی داهێنەر",
    creative_studio_desc: "دەنگ و مۆسیقا",
    impact_hub: "ناوەندی گەشە",
    impact_hub_desc: "گزارشی مانگانە",
    legacy_hub: "میراثی ماندگار",
    legacy_hub_desc: "وەسێتنامە",
    philosophy_hub: "ناوەندی فەلسەفە",
    philosophy_hub_desc: "دۆزینەوەی بەهاکان",
    // Calm
    calm_companion: "هاوەڵی ئارامی",
    anxiety_management: "بەڕێوەبردنی دڵەڕاوکێ",
    checkin_tab: "هەڵسەنگاندن",
    ladder_tab: "پلیکانەی ترس",
    cbt_tab: "گۆڕینی بیرکردنەوە",
    safety_tab: "سەلامەتی",
    calm_analyze_btn: "شیکاری باری دەروونی",
    calm_panic_mode: "باری نائاسایی",
  },
  [Language.PERSIAN]: {
    appName: "هاورێ",
    tagline: "هاورێ؛ دستیار هوشمند سبک زندگی و مربی آرامش شما",
    welcome: "سلام، {name} عزیز!",
    dashboard: "داشبورد",
    companion_live: "مرکز بیان",
    chat: "گفتگو",
    calm: "آرامش",
    social_training: "آموزش اجتماعی",
    community: "جامعه",
    companion: "همسفر و ادبیات",
    modules: "ابزارها",
    timeline: "خاطرات",
    profile: "پروفایل",
    logout: "خروج",
    start_journey: "شروع گشت",
    select_companion: "انتخاب همسفر",
    name_placeholder: "نام خود را بنویسید...",
    continue: "ادامه",
    save: "ذخیره",
    cancel: "انصراف",
    edit_profile: "ویرایش پروفایل",
    language: "زبان",
    kurdish: "کردی",
    persian: "فارسی",
    back: "بازگشت",
    send: "ارسال",
    end_session: "پایان",
    try_again: "مجدد",
    physical: "جسمی",
    mental: "ذهنی",
    social: "اجتماعی",
    professional: "حرفه‌ای",
    financial: "مالی",
    balance: "توازن زندگی",
    level: "سطح",
    xp: "امتیاز",
    ai_analysis: "تحلیل هاورێ",
    immediate_calm: "آرامش فوری",
    memory_record: "ثبت خاطره",
    social_practice: "تمرین",
    chat_status: "فعال",
    chat_welcome_title: "به چت خوش آمدید",
    chat_welcome_desc: "هاورێ برای گفتگو با شما آماده است.",
    chat_thinking: "در حال فکر کردن...",
    chat_placeholder: "پیامی بنویسید...",
    onboarding_title: "به هاورێ خوش آمدید",
    onboarding_subtitle: "نام شما چیست؟",
    onboarding_privacy: "اطلاعات شما محفوظ است.",
    install_title: "نصب اپلیکیشن",
    install_desc: "برای سرعت بیشتر اپلیکیشن را نصب کنید.",
    install_btn: "همین حالا نصب کن",
    select_country: "انتخاب کشور",
    country_kurdistan: "کردستان",
    country_iran: "ایران",
    country_iraq: "ایران",
    country_other: "کشورهای دیگر",
    select_ai_engine: "موتور هوش مصنوعی",
    engine_desc: "می‌توانید موتور پاسخگویی هاورێ را تغییر دهید.",
    gemini_label: "جمینای (Google)",
    deepseek_label: "DeepSeek",
    grok_label: "Grok (xAI)",
    // Personality
    personality_title: "شخصیت هاورێ را انتخاب کنید",
    personality_subtitle: "هاورێ می‌تواند با شخصیت‌های مختلف همراه شما باشد.",
    personality_butterfly: "پروانه تحول",
    personality_butterfly_desc: "اجتماعی و پرانرژی",
    personality_butterfly_details: "شما را به تجربه چیزهای نو تشویق می‌کند.",
    personality_mountain: "کوه استوار",
    personality_mountain_desc: "ثابت‌قدم و قابل اعتماد",
    personality_mountain_details: "با آرامش شما را راهنمایی می‌کند.",
    personality_lamp: "چراغ خرد",
    personality_lamp_desc: "روشنفکر و منطقی",
    personality_lamp_details: "با دانش راه را روشن می‌کند.",
    personality_gardener: "باغبان زندگی",
    personality_gardener_desc: "دلسوز و حامی",
    personality_gardener_details: "مراقب رشد شما خواهد بود.",
    // Live Companion Keys
    live_status_connected: "متصل",
    live_status_connecting: "در حال اتصال...",
    speech_coach_ready: "آماده تمرین بیان هستی؟",
    speech_mode_tech: "تخصصی",
    speech_mode_public: "سخنرانی",
    speech_mode_poetic: "ادبی",
    speech_mode_daily: "روزمره",
    speech_tip_tech: "از کلمات دقیق و منطقی استفاده کن.",
    speech_tip_public: "با صدای رسا و اعتماد به نفس صحبت کن.",
    speech_tip_poetic: "احساس خود را در کلام جاری کن.",
    speech_how_it_works: "چطور کار می‌کند؟",
    speech_step_1: "یک مۆد انتخاب کنید.",
    speech_step_2: "دکمه شروع را بزنید.",
    speech_step_3: "به زبان کوردی یا فارسی صحبت کنید.",
    speech_metric_clarity: "وضوح",
    speech_metric_pace: "سرعت",
    speech_metric_emotion: "احساس",
    speech_coach_feedback: "بازخورد مربی",
    // Tools
    tools_portal: "پورتال ابزارها",
    tools_portal_desc: "ابزارهای هوشمند برای نظم زندگی.",
    advanced_ai: "هوش مصنوعی پیشرفته",
    advanced_ai_desc: "تحلیل عمیق و پیش‌بینی آینده.",
    cooking_tool: "آشپزی",
    cooking_tool_desc: "ساخت دستور پخت.",
    tasks_tool: "کارها",
    tasks_tool_desc: "تقسیم کارهای بزرگ.",
    health_tool: "سلامت",
    health_tool_desc: "برنامه سلامت و انرژی.",
    finance_tool: "مالی",
    finance_tool_desc: "تحلیل مخارج.",
    learning_tool: "یادگیری",
    learning_tool_desc: "خلاصه مطالب.",
    travel_tool: "سفر",
    travel_tool_desc: "برنامه سفر.",
    back_to_hub: "بازگشت به پورتال",
    generate_now: "تولید کن",
    // Community
    safe_community: "جامعه امن",
    anonymous_chat_desc: "گفتگو کنید بدون اینکه نامتان فاش شود.",
    identity_protected: "هویت شما محفوظ است",
    comm_type_msg: "پیامی بنویسید...",
    comm_first_msg: "اولین پیام را بفرستید!",
    rooms_tab: "اتاق‌ها",
    companions_tab: "همسفرها",
    comm_find_companion: "یافتن همسفر",
    comm_companion_desc: "کسی را پیدا کنید که با طرز فکر شما همسو باشد.",
    comm_searching: "در حال جستجو...",
    comm_find_btn: "جستجوی همسفر",
    comm_active_members: "{count} عضو فعال",
    anonymous_name_is: "نام شما در اینجا: {name}",
    // Social
    social_academy_title: "آکادمی روابط اجتماعی",
    social_academy_desc: "هنر گفتگو و بیان را در موقعیت‌های مختلف بیاموزید.",
    social_start_sim: "شروع شبیه‌ساز",
    social_feedback_title: "تحلیل مربی",
    social_back_to_groups: "بازگشت به گروه‌ها",
    social_principles: "اصول گفتگو",
    // Companion Hub Extra
    wisdom_day: "حکمت و پند",
    poetry_literature: "شعر و ادب",
    fun_time: "شوخی و سرگرمی",
    joke_contest: "مسابقه جوک",
    favorites: "علاقه‌مندی‌ها",
    motivational: "انگیزشی",
    philosophical: "فلسفی",
    romantic: "عاشقانه",
    calm_cat: "آرامش‌بخش",
    classic_poetry: "شعر کلاسیک",
    modern_poetry: "شعر نو",
    mystic_poetry: "شعر عرفانی",
    haiku_poetry: "هایکو",
    generating_content: "در حال تولید...",
    select_topic_smile: "موضوعی انتخاب کنید تا هاورێ برایتان بسازد",
    joke_judge: "یک جوک بنویسید",
    send_to_judge: "ارسال به داور",
    no_favorites: "لیست خالی است.",
    wisdom_letter_title: "نامه حکمت",
    // Prediction
    prediction_lab_title: "آزمایشگاه پیش‌بینی",
    prediction_lab_desc: "تحلیل سناریوهای زندگی و احتمالات آینده.",
    decision_simulator: "شبیه‌ساز تصمیم‌گیری",
    predictive_alerts: "هشدارهای پیش‌بینانه",
    decision_prompt: "چه تصمیمی در ذهن دارید؟",
    prediction_scenario_btn: "تحلیل سناریو",
    prediction_impact_5yr: "تاثیر ۵ ساله",
    // Digital Balance
    digital_balance: "تعادل دیجیتال",
    offline_challenge: "چالش آفلاین",
    micro_learning: "یادگیری خرد",
    daily_class: "کلاس روزانه",
    creative_studio: "استودیو خلاق",
    creative_studio_desc: "صدا و موسیقی",
    impact_hub: "مرکز رشد",
    impact_hub_desc: "گزارش ماهانه",
    legacy_hub: "میراث ماندگار",
    legacy_hub_desc: "وصیت دیجیتال",
    philosophy_hub: "مرکز فلسفه",
    philosophy_hub_desc: "کشف ارزش‌ها",
    // Calm
    calm_companion: "همیار آرامش",
    anxiety_management: "مدیریت اضطراب",
    checkin_tab: "ارزیابی",
    ladder_tab: "نردبان ترس",
    cbt_tab: "تغییر باورها",
    safety_tab: "ایمنی",
    calm_analyze_btn: "تحلیل وضعیت ذهنی",
    calm_panic_mode: "وضعیت اضطراری",
  }
};
